



































































































































import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SwiperCase from "@/zh-website/src/components/website/Swiper/SwiperCase.vue";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperShare from "@/zh-website/src/components/website/Swiper/SwiperShare.vue";
import SwiperPartner from "@/zh-website/src/components/website/Swiper/SwiperPartner.vue";
import { Component, Vue } from "vue-property-decorator";
import LoginForm from "@/zh-website/src/views/login/LoginForm.vue";
import { PartnerService } from "@/zh-website/src/views/partner/service";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
@Component({
  components: {
    Swiper,
    SwiperSlide,
    Banner,
    SwiperCase,
    SwiperNews,
    SwiperShare,
    SwiperPartner
  }
})
export default class PartnerIndex extends Vue {
  lately = [];
  showmode = false;
  showGallery = [];
  mySwiper = this.$refs.mySwiper;
  bannerData = {
    font1: "",
    font2: "",
    font3: "",
    button: "",
    style: {
      "background-image": 'url("' + require("../../assets/pic01.jpg") + '")',
      height: "495px"
    }
  };
  SwiperShare2 = {
    slidesPerView: 3,
    spaceBetween: 0,
    loop: true,
    autoplay: true,
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 0
      }
    }
  };
  items = [
    {
      src: require("../../assets/img10.jpg"),
      names: "专家权益"
    },
    {
      src: require("../../assets/img10.jpg"),
      names: "专家网络介绍"
    },
    {
      src: require("../../assets/img10.jpg"),
      names: "专家常见问题"
    }
  ];
  caseList: any[] = [];

  caseJump = "/partner/details/";
  defaultIndex = 0;
  listCase = [];
  activeIndex = "1";
  ChannelList = [
    {
      tag1: 0,
      updateDate: 1586483118000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "查询渠道伙伴",
      dictCode: "036",
      content1:
        '<p><br/></p><p style="text-align: center;"><span style="text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
      id: "h59c13wjj4gRq98A066G02338I11585636693501",
      field2: require("../../assets/partner_channel3.png"),
      group: "036",
      createDate: 1585636693000
    },
    {
      tag1: 0,
      updateDate: 1632907658000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "了解政策权益",
      dictCode: "036",
      content2: "",
      content1:
        '<p><span style="text-align: center;"></span><br/></p><p style="text-align: center;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-align: center;"></span><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span></span></p><p style="text-align:center"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 21px;">关于规范渠道授权的通知</span></strong><strong><span style="font-size: 21px;"></span></strong><strong><span style="font-size: 21px;"></span></strong></span></p><p style="line-height:150%"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">致<span style="text-decoration: underline;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>：</span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong><strong><span style="font-size: 16px; line-height: 150%;"></span></strong></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">为维护市场秩序，保障双方的共同利益，我司将加强对渠道项目的商务授权管理，请按相关流程开展合作：<span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; color: red;"> </span></span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于需开具商务《授权函》的项目，请渠道伙伴联系我方业务人员，相应项目经评审通过后，我方会以正式授权文件形式给予必要的商务支持。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">对于未获得我司授权却以我司名义参与投标，若发生交付等各风险，我司有追责的权利；同时我司会按情节严重情况，考虑是否取消合作。</span></p><p style="text-align:left;text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">以上通知若合作中遇到问题，反馈。</span></p><p style="text-indent:32px;line-height:150%"><span style="font-size: 16px; line-height: 150%; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">特此通知。</span></p><p style="text-align: center;"><span style="text-align: center; color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; background-color: rgb(255, 255, 255);"></span><br/></p><p><br/></p><p style="text-indent: 32px; line-height: 150%; text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%;">浙江华为通信技术有限公司</span></strong></span></p><p style="text-align: right;"><span style="font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 16px; line-height: 150%; font-family: 宋体;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></strong></span>日期：2021年9月30日</p><p style="text-align: right;"><br/></p>',
      id: "N26Dg6C459EpayNCV66PjPsY81a1585636685540",
      field2: require("../../assets/partner_channel1.png"),
      group: "036",
      createDate: 1585636685000
    },
    {
      tag1: 0,
      updateDate: 1586483045000,
      plural: 0,
      reading: 0,
      collection: 0,
      sort: 1,
      tag2: 0,
      isShow: 1,
      tag3: 0,
      field1: "成为渠道伙伴",
      dictCode: "036",
      content1:
        '<p style="text-align: center;"><br/></p><p style="text-align: center;"><span style="color: rgb(112, 112, 112); font-family: 微软雅黑, 黑体, 宋体; text-align: center; background-color: rgb(255, 255, 255);">渠道合作相关内容待开放，敬请期待</span></p>',
      id: "yZ2508je79lmSU0Ulm9Ajz40F5P1581311981676",
      field2: require("../../assets/partner_channel2.png"),
      group: "036",
      createDate: 1581311981000
    }
  ];
  rightNew = [];
  leftNew = [];
  newjump = "/home/news/det/";
  showSearch = false;
  showImg = true;
  claseJump = "/partner/course/";
  datalist2 = [
    // {
    //   id: 1,
    //   keywords:
    //     "background-image:url('" + require("../../assets/about_60.png") + "')",
    //   dictName: "面授课程",
    //   extend: ""
    // },
    // {
    //   id: 2,
    //   keywords:
    //     "background-image:url('" + require("../../assets/img11.jpg") + "')",
    //   dictName: "在线课程",
    //   extend: ""
    // },
    {
      id: 3,
      keywords:
        "background-image:url('" + require("../../assets/about_61.png") + "')",
      dictName: "课程案例",
      extend: ""
    }
  ] as any;
  mounted() {
    this.getCase();
    this.getNews();
  }
  switchTo() {
    this.$router.push("/home/news/det/1714215829141069826");
  }
  on_top_enter() {
    (this.mySwiper as any).autoplay.stop();
  }
  on_top_leave() {
    (this.mySwiper as any).autoplay.start();
  }
  getNews() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.rightNew = [];
        }
      }
    );
  }
  //获取合作案例
  getCase() {
    this.caseList.length = 0;
    PartnerService.getCooperationCaseList({ pageNum: 1, pageSize: 10 }).then(
      (res: any) => {
        //
        res.data.list.forEach((item: any, index: number) => {
          this.caseList.push({
            id: item.id,
            field3: `background-image:url('${item.resourceUrl}')`,
            dictName: item.classificationName,
            field1: item.title
          });
        });
      }
    );
  }
}
